import { getDashboardTopRevenueApi } from 'app/services/homePageApi';
import React, { useMemo } from 'react';
import {
  DASHBOARD_REPORT_TYPE,
  toRankingRows,
  useDashboardReport,
} from '../hooks/useDashboardReport';
import TopRankingReport, { ORANGE_SCALE } from './TopRankingReport';

interface ITopProductReportProps {
  translations: any;
}

export function TopProductReport(props: ITopProductReportProps) {
  const { translations } = props;
  const { rows, period, onChangePeriod, isLoading } = useDashboardReport({
    actionApi: getDashboardTopRevenueApi,
    type: DASHBOARD_REPORT_TYPE.SHOW,
  });

  const data = useMemo(() => toRankingRows(rows), [rows]);

  return (
    <TopRankingReport
      translations={translations}
      title={translations?.['b2b.txt.top10BestSellingProducts'] ?? ''}
      data={data}
      colorScale={ORANGE_SCALE}
      period={period}
      onChangePeriod={onChangePeriod}
      isLoading={isLoading}
    />
  );
}

export default TopProductReport;
